
import { defineComponent } from 'vue'
import BaseButton from '../BaseButton/index.vue'

export default defineComponent({
	components: {
		BaseButton
	}
})
